export default "__VITE_ASSET__D0$XQ9uo__"